<template>
  <router-view/>
</template>

<style>
html,
body {
  width: 100%;
  max-width: 100%;
  margin: 0;
  overflow-x: hidden;
  overscroll-behavior-x: none;
  touch-action: pan-y;
}

* {
  box-sizing: border-box;
  min-width: 0;
}

img,
video,
canvas,
svg {
  max-width: 100%;
}

#app {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  overscroll-behavior-x: none;
  touch-action: pan-y;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#app * {
  touch-action: pan-y;
}

p,
div,
span,
strong,
a,
li,
td {
  overflow-wrap: anywhere;
  word-break: break-word;
}

.el-row {
  max-width: 100%;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.el-col {
  max-width: 100%;
}

table {
  max-width: 100%;
  table-layout: fixed;
  word-break: break-word;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
